import * as React from 'react'
import styled from 'styled-components/macro'
import {QUERIES} from './constants'
import {submitQuoteRequest} from 'common/sendEmail'
import {
  Line,
  StyledLabel,
  StyledInput,
  StyledForm,
  Title,
  StyledSelect,
  Button,
} from 'common/ModalFormComponents'

const Container = styled.div`
  display: none;
  @media ${QUERIES.tabletAndUp} {
    display: flex;
  }
  color: var(--dark-grey);
  background-color: white;
  height: 394px;
  width: 737px;
  padding: 40px 56px;
  font-family: 'Mulish';
  font-size: calc(16 / 16 * 1rem);
  font-weight: 300;
  box-shadow: 10px 10px 10px rgba(26, 26, 26, 0.65);
  position: absolute;
  top: 475px;
  transition: right 1s ease-in-out;
  right: ${p => (p.open ? '0' : '-737px')};
  border-radius: 0 0 0 5px;
`

const Tab = styled.div`
  position: absolute;
  height: 208px;
  width: 48px;
  top: 0px;
  left: -48px;
  background-color: var(--light-green);
  border-radius: 5px 0 0 5px;
  cursor: pointer;
  /* Sub-Heading/XS */

  font-family: 'Rubik';
  font-style: italic;
  font-size: calc(16 / 16 * 1rem);
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: var(--white);
  span {
    transform: rotate(-90deg);
    white-space: nowrap;
  }
  /* filter: drop-shadow(10px 10px 10px rgba(26, 26, 26, 0.65)); */
`

const RequestQuotePopup = ({type}) => {
  const [open, setOpen] = React.useState(false)
  const [submitting, setSubmitting] = React.useState(false)
  const [submitSuccess, setSubmitSuccess] = React.useState(false)
  return (
    <Container open={open}>
      <Tab onClick={() => setOpen(!open)}>
        <span>Request a Quote</span>
      </Tab>
      <StyledForm
        name="request-quote"
        method="POST"
        data-netlify={true}
        id="request-quote"
      >
        <Title>Request a Quote</Title>
        <Line>
          <StyledLabel name="Service" htmlFor="service">
            Which service are you interested in?
          </StyledLabel>
          <StyledSelect name="Service" id="service">
            <option value="Event Planning">Event Planning</option>
            <option value="Sweet Spot Software">Sweet Spot Software</option>
            {/* <option value="Event Liability Coverage">
              Event Liability Coverage
            </option> */}
            <option value="Apparel">Apparel</option>
            <option value="Golfer Gifts">Golfer Gifts</option>
            <option value="Promotional Products">Promotional Products</option>
            <option value="Hole-in-One Packages">Hole-in-One Packages</option>
            <option value="Putting & Shootout Contests">
              Putting & Shootout Contests
            </option>
            <option value="Signs & Banners">Signs & Banners</option>
            <option value="Golf Ball Launcher">Golf Ball Launcher</option>
            <option value="Cigar Rolling">Cigar Rolling</option>
            {/* <option value="Club Rentals">Club Rentals</option> */}
            <option value="Photography">Photography</option>
          </StyledSelect>
        </Line>
        <Line>
          <StyledLabel name="Contact Name" htmlFor="First Name">
            Contact Name
          </StyledLabel>
          <StyledInput width="228" name="First Name"></StyledInput>
          <StyledInput width="228" name="Last Name"></StyledInput>
        </Line>
        <Line>
          <StyledLabel name="email" htmlFor="email">
            Email
          </StyledLabel>
          <StyledInput width="553" name="email" id="email"></StyledInput>
        </Line>
        <Line>
          <StyledLabel name="Phone" htmlFor="Phone">
            Phone
          </StyledLabel>
          <StyledInput width="546" name="Phone"></StyledInput>
        </Line>
        <Line>
          {submitSuccess ? (
            <div>Request Sent!</div>
          ) : (
            <Button
              type="button"
              disabled={submitting}
              onClick={() =>
                submitQuoteRequest({
                  setSubmitSuccess,
                  setSubmitting,
                  formID: 'request-quote',
                })
              }
              submitting={submitting}
            >
              {submitting ? 'Sending...' : 'Send'}
            </Button>
          )}
        </Line>
        <input type="hidden" name="form-name" value="request-quote" readOnly />
        <input type="hidden" name="Type" value={type} readOnly />
      </StyledForm>
    </Container>
  )
}
export default RequestQuotePopup
